/* eslint-disable react/jsx-no-bind */
import React, { useEffect, useState } from 'react';
import { makeStyles } from 'tss-react/mui';
import Icon from '../icons/components/Icon';
import { IconCheck, IconCopy } from '../icons/svg';
import { copyText } from '../util/copyText.web';
import { withPixelLineHeight } from "../styles/functions.web";
const useStyles = makeStyles()(theme => {
    return {
        copyButton: {
            ...withPixelLineHeight(theme.typography.bodyShortBold),
            borderRadius: theme.shape.borderRadius,
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            padding: `${theme.spacing(2)} ${theme.spacing(3)}`,
            width: "100%",
            boxSizing: "border-box",
            background: theme.palette.iisightBrandBackground,
            cursor: "pointer",
            color: theme.palette.text01,
            "&:hover": {
                backgroundColor: theme.palette.iisightBrand700
            },
            "&.clicked": {
                background: theme.palette.success02
            },
            "& > div > svg": {
                fill: theme.palette.icon01
            }
        },
        content: {
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
            maxWidth: 292,
            marginRight: theme.spacing(3),
            "&.selected": {
                fontWeight: 600
            }
        }
    };
});
let mounted;
/**
 * Component meant to enable users to copy the conference URL.
 *
 * @returns {React$Element<any>}
 */
function CopyButton({ accessibilityText, className = '', displayedText, textToCopy, textOnHover, textOnCopySuccess, id }) {
    const { classes, cx } = useStyles();
    const [isClicked, setIsClicked] = useState(false);
    const [isHovered, setIsHovered] = useState(false);
    useEffect(() => {
        mounted = true;
        return () => {
            mounted = false;
        };
    }, []);
    async function onClick() {
        setIsHovered(false);
        const isCopied = await copyText(textToCopy);
        if (isCopied) {
            setIsClicked(true);
            setTimeout(() => {
                if (mounted) {
                    setIsClicked(false);
                }
            }, 2500);
        }
    }
    function onHoverIn() {
        if (!isClicked) {
            setIsHovered(true);
        }
    }
    function onHoverOut() {
        setIsHovered(false);
    }
    function onKeyPress(e) {
        if (onClick && (e.key === " " || e.key === "Enter")) {
            e.preventDefault();
            onClick();
        }
    }
    function renderContent() {
        if (isClicked) {
            return (React.createElement(React.Fragment, null,
                React.createElement("div", { className: cx(classes.content, "selected") },
                    React.createElement("span", { role: "alert" }, textOnCopySuccess)),
                React.createElement(Icon, { size: 24, src: IconCheck })));
        }
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { className: classes.content },
                React.createElement("span", null,
                    " ",
                    isHovered ? textOnHover : displayedText,
                    " ")),
            React.createElement(Icon, { size: 24, src: IconCopy })));
    }
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { "aria-describedby": displayedText === textOnHover ? undefined : `${id}-sr-text`, "aria-label": displayedText === textOnHover ? accessibilityText : textOnHover, className: cx(className, classes.copyButton, isClicked ? " clicked" : ""), id: id, onBlur: onHoverOut, onClick: onClick, onFocus: onHoverIn, onKeyPress: onKeyPress, onMouseOut: onHoverOut, onMouseOver: onHoverIn, role: "button", tabIndex: 0 }, renderContent()),
        displayedText !== textOnHover && (React.createElement("span", { className: "sr-only", id: `${id}-sr-text` }, accessibilityText))));
}
export default CopyButton;
